<template>
    <v-dialog v-model="dialog" width="800" fullscreen persistent>
        <v-card style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-card elevation="3">
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                            <h3 class="text-body-2 font-weight-bold">Title</h3>
                                            <p class="text-grey-darken-1">{{ repTitleData.title }}</p>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <h3 class="text-body-2 font-weight-bold">Special Order Number</h3>
                                            <p class="text-grey-darken-1">{{ repTitleData.so_number }}</p>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <h3 class="text-body-2 font-weight-bold">Duration</h3>
                                            <p class="text-grey-darken-1">{{ formatDate(repTitleData.start_date) }} - {{ formatDate(repTitleData.end_date) }}</p>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <h3 class="text-body-2 font-weight-bold">Category</h3>
                                            <p v-if="repTitleData.category == 'Res'" class="text-grey-darken-1">Research</p>
                                            <p v-if="repTitleData.category == 'Ext'" class="text-grey-darken-1">Extension</p>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" class="mt-6">
                            <v-row dense align="center">
                                <v-col cols="12" md="6">
                                    <span class="font-weight-bold text-h6">Leader</span>
                                </v-col>
                                <v-col class="text-right" cols="12" md="6">
                                    <v-btn
                                    v-if="leaderData.length <= 0"
                                    @click="showAddLeaderDialog()"
                                    prepend-icon="mdi-plus"
                                    class="mt-1 rounded-lg"
                                    color="routesColor"
                                    height="40px"
                                    elevation="2">
                                        Add Leader
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" class="mt-1">
                                    <v-card class="dt-container">    
                                        <v-data-table
                                            :mobile="isMobileOrTablet()"
                                            :headers="repTitleData.is_approved == true ? approvedHeaders : headers"
                                            :items="leaderData"
                                            :loading="loading"
                                            hide-default-footer
                                        >
                                        <template v-slot:loading>
                                            <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                        </template>
                                        <template v-slot:item.unit="{ item }">
                                            <span v-if="item.unit == 'teaching'">Teaching</span>
                                            <span v-if="item.unit == 'non-teaching'">Non-Teaching</span>
                                        </template>
                                        <template v-slot:item.datecreated="{ item }">
                                            <span>{{ formatDate(item.datecreated)}} </span>
                                        </template>
                                        <template v-slot:item.is_approved="{ item }">
                                            <v-chip v-if="repTitleData.is_approved == true" size="small" color="green" variant="elevated">
                                                Yes
                                            </v-chip>
                                            <v-chip v-else size="small" color="gray">
                                                No
                                            </v-chip>
                                        </template>
                                        <template v-slot:[`item.action`]="{ item }">
                                            <div v-if="repTitleData.is_approved != true" class="d-flex justify-end ga-2">
                                                <v-btn @click="showRemoveDialog(item)" size="small" variant="outlined" text="Remove" color="red" elevation="3"></v-btn>
                                            </div>
                                        </template>
                                        </v-data-table>
                                    </v-card>
                                </v-col>   
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row dense class="mt-8">
                        <v-col cols="12">
                            <v-row dense align="center">
                                <v-col cols="12" md="6">
                                    <span class="font-weight-bold text-h6">Members</span>
                                </v-col>
                                <v-col class="text-right" cols="12" md="6">
                                    <v-btn
                                    v-if="repTitleData.is_approved != true"
                                    @click="showAddMemberDialog()"
                                    prepend-icon="mdi-plus"
                                    class="mt-1 rounded-lg"
                                    color="routesColor"
                                    height="40px"
                                    elevation="2">
                                        Add Member
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" class="mt-1">
                                    <v-card class="dt-container">    
                                        <v-data-table
                                            :mobile="isMobileOrTablet()"
                                            :headers="repTitleData.is_approved == true ? approvedHeaders : headers"
                                            :items="membersData"
                                            :loading="loading"
                                            hide-default-footer
                                        >
                                        <template v-slot:loading>
                                            <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                        </template>
                                        <template v-slot:item.unit="{ item }">
                                            <span v-if="item.unit == 'teaching'">Teaching</span>
                                            <span v-if="item.unit == 'non-teaching'">Non-Teaching</span>
                                        </template>
                                        <template v-slot:item.datecreated="{ item }">
                                            <span>{{ formatDate(item.datecreated)}} </span>
                                        </template>
                                        <template v-slot:item.is_approved="{ item }">
                                            <v-chip v-if="repTitleData.is_approved == true" size="small" color="green" variant="elevated">
                                                Yes
                                            </v-chip>
                                            <v-chip v-else size="small" color="gray">
                                                No
                                            </v-chip>
                                        </template>
                                        <template v-slot:[`item.action`]="{ item }">
                                            <div v-if="repTitleData.is_approved != true" class="d-flex justify-end ga-2">
                                                <v-btn @click="showRemoveDialog(item)" size="small" variant="outlined" text="Remove" color="red" elevation="3"></v-btn>
                                            </div>
                                        </template>
                                        </v-data-table>
                                    </v-card>
                                </v-col>   
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <!-- <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions> -->
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDelete" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want delete this leader/member?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, The action cannot be reversible.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmDelete = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="deleteUser()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <RepUnitDialog ref="RepUnitDialog" @refresh="initData()"/>
</template>

<script>
import axios from 'axios';
import RepUnitDialog from './Sub-Dialogs/RepUnitDialog.vue'
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    emits: ["refresh"],
    components: {
        RepUnitDialog
    },
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            confirmDelete: false,
            itemToDelete: null,

            headers: [
                { title: 'Faculty Name', align: 'start', sortable: true, key: 'faculty_name' },
                { title: 'Unit', align: 'start', sortable: true, key: 'unit' },
                { title: 'Unit Loading', align: 'start', sortable: true, key: 'unit_loading' },
                { title: 'Date Assigned', align: 'start', sortable: true, key: 'datecreated' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            approvedHeaders:[
                { title: 'Faculty Name', align: 'start', sortable: true, key: 'faculty_name' },
                { title: 'Unit', align: 'start', sortable: true, key: 'unit' },
                { title: 'Unit Loading', align: 'start', sortable: true, key: 'unit_loading' },
                { title: 'Date Assigned', align: 'start', sortable: true, key: 'datecreated' },
                { title: 'Is Workload Approved', align: 'end', sortable: true, key: 'is_approved'},
            ],

            repTitleData: [],

            leaderData: [],
            membersData: []
        }
    },
    methods: {
        init(data){
            this.dialog = true
            this.dialog_title = 'REP Faculty Unit'
            this.dialog_sub_title = 'Add new rep load release'

            this.repTitleData = data
            this.initData()
        },
        initData(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/rep-unit-load/findAllByTitle/' + this.repTitleData.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.leaderData = res.data.filter(item => item.role === 'Leader')
                    this.membersData = res.data.filter(item => item.role === 'Member')
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        deleteUser(){
            const { showSnackbar } = useSnackbar()
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.delete(process.env.VUE_APP_SERVER_URL + '/rep-unit-load/' + this.itemToDelete.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    this.loading = false
                    showSnackbar('Leader/Member successfully removed!')
                    this.confirmDelete = false
                    this.initData()
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showAddLeaderDialog(){
            this.$refs.RepUnitDialog.initAddLeader(this.repTitleData)
        },
        showAddMemberDialog(){
            this.$refs.RepUnitDialog.initAddMember(this.repTitleData)
        },
        showRemoveDialog(data){
            this.itemToDelete = data
            this.confirmDelete = true
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
    }
})
</script>

<style scoped>

</style>